export default __webpack_public_path__ + "static/media/icon-search.f282b348.svg";